import { render, staticRenderFns } from "./detailHoursProjects.vue?vue&type=template&id=92a5ddc6&"
import script from "./detailHoursProjects.vue?vue&type=script&lang=js&"
export * from "./detailHoursProjects.vue?vue&type=script&lang=js&"
import style0 from "./detailHoursProjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports